import { GET_ROOT_TOPOLOGY_API_FAIL, GET_ROOT_TOPOLOGY_API_REQUEST, GET_ROOT_TOPOLOGY_API_SUCCESS, GET_TOPOLOGY_INFO_API_FAIL, GET_TOPOLOGY_INFO_API_REQUEST, GET_TOPOLOGY_INFO_API_SUCCESS } from "../../constants/graphConstants/homeDashboardGraphConstant";

/**
 * Reducer function for managing Mesh Topology graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const meshTopologyReducer = (
    state = {
        loading: false,
        topologyRootData: {},
        topologyInfoLoading: false,
        topologyInfoData: {},

    },
    action
) => {
    switch (action.type) {
        case GET_ROOT_TOPOLOGY_API_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_ROOT_TOPOLOGY_API_SUCCESS:
            return {
                ...state,
                topologyRootData: action.payload,
                loading: false,
                error: null,
            };
        case GET_ROOT_TOPOLOGY_API_FAIL:
            return {
                ...state,
                topologyRootData: {},
                error: action.payload,
                loading: false,
            };
         case GET_TOPOLOGY_INFO_API_REQUEST:
            return {
                ...state,
                topologyInfoLoading: true,
            };

        case GET_TOPOLOGY_INFO_API_SUCCESS:
            return {
                ...state,
                topologyInfoData: action.payload,
                topologyInfoLoading: false,
                error: null,
            };

        case GET_TOPOLOGY_INFO_API_FAIL:
            return {
                ...state,
                topologyInfoData: {},
                topologyInfoLoading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

